import { TOP_BAR_HEIGHT_PX } from "../theme";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:5000";

export const APP_TOP_BAR_HEIGHT = TOP_BAR_HEIGHT_PX / 8; // in 8px units (76px); matches sidebar logo section height

export const ROW_HEIGHT = 52; // Example row height, adjust as needed
export const HEADER_FOOTER_HEIGHT = 56 + 37; // Example header height, adjust as needed


export const DARK_THEME_COLOR = "rgb(29, 39, 49)";
export const MID_DARK_THEME_COLOR = "rgb(58,79,98)";
export const MID_THEME_COLOR = "rgb(25,118,210)";
export const MID_LIGHT_THEME_COLOR = "rgb(123,150,175)";
export const LIGHT_THEME_COLOR = "rgb(211,220,228)";


export const THEME_LIGHT_GREY = "rgb(242, 246, 250)";
export const THEME_LIGHT_GREEN = "rgb(220, 241, 219)";
export const THEME_GREEN = "rgb(0, 128, 0)";